import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Badge from 'react-bootstrap/Badge';
import { useTranslation } from '@separate/hooks/translation';
import { Amex, Mastercard, PODERcardGradient, Visa } from '@separate/icons';
import styles from './paymentMethodInfoCard.module.scss';

export default function CreditCardInfoCard({ card, primary }) {
  const { t } = useTranslation();

  const defaultCardIcon = () => {
    return (
      <div className={styles.defaultIcon}>
        <PODERcardGradient />
      </div>
    );
  };

  const brandMapping = {
    amex: {
      name: 'American Express',
      icon: Amex,
    },
    diners: {
      name: 'Diners Club',
      icon: defaultCardIcon,
    },
    discover: {
      name: 'Discover',
      icon: defaultCardIcon,
    },
    jcb: {
      name: 'JCB',
      icon: defaultCardIcon,
    },
    mastercard: {
      name: 'Mastercard',
      icon: Mastercard,
    },
    unionpay: {
      name: 'UnionPay',
      icon: defaultCardIcon,
    },
    visa: {
      name: 'Visa',
      icon: Visa,
    },
    unknown: {
      name: 'Card',
      icon: defaultCardIcon,
    }
  };

  function formatMonth(month) {
    return String(month).padStart(2, '0');
  }

  function formatYear(year) {
    return String(year).slice(-2);
  }

  const brand = brandMapping[card.brand];
  const BrandIcon = brand.icon;

  return (
    <div className={cx(styles.infoCard, { [styles.primary]: primary })}>
      {primary && (
        <Badge pill className={styles.pill}>
          {t('user.profile.default')}
        </Badge>
      )}
      <BrandIcon className={styles.cardIcon} />
      <div>
        <div className={styles.cardNumber}>
          {`${brand.name} xxxx ${card.last4}`}
        </div>
        <div className={styles.expiration}>
          {`${t('user.profile.expires_on')} ${formatMonth(card.exp_month)}/${formatYear(card.exp_year)}`}
        </div>
      </div>
    </div>
  );
}

CreditCardInfoCard.propTypes = {
  card: PropTypes.shape({
    brand: PropTypes.oneOf(['amex', 'diners', 'discover', 'jcb', 'mastercard', 'unionpay', 'visa', 'unknown']),
    last4: PropTypes.string,
    exp_month: PropTypes.number,
    exp_year: PropTypes.number,
  }).isRequired,
  primary: PropTypes.bool,
};
